import React, { useState } from 'react';
import { Toast } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import { useTvsState } from '../../utils/useTvsState';
import './VerificationSuccessPage.css';

const VerificationSuccessPage: React.FC = () => {
  const { t } = useTranslation();

  const [isToastOpen, setIsToastOpen] = useState(true);
  const [, setTvState] = useTvsState();
  return (
    <>
      <div className='grid grid-flex grid-justify-center'>
        <Toast
          className='verification-success-toast verification-success-toast-dark'
          headline={t('VerificationSuccessPage.successHeading')}
          message={t('VerificationSuccessPage.successMessage')}
          statusType='confirm'
          onClose={() => {
            setIsToastOpen(false);
            setTvState('');
          }}
          isOpen={isToastOpen}
          withCloseButton={true}
          isAutoHide={false}
        />
      </div>
    </>
  );
};

export default VerificationSuccessPage;
